export default {
    getAmbienceCategories: { method: 'get', url: 'ambiences/categories' },
    postAmbienceCategories: { method: 'post', url: 'ambiences/categories' },
    updateAmbienceCategories: { method: 'put', url: 'ambiences/categories/{id}' },
    deleteAmbienceCategories: { method: 'delete', url: 'ambiences/categories/{id}' },
}
